import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { createPortal } from 'react-dom';

import {
  Container,
  Content,
  ImageWrapper,
  CloseButton,
  Title,
  View,
} from './index.styled';

/**
 * A safe portal component that only renders on the client.
 */
const Portal = ({ children }) => {
  const [mounted, setMounted] = React.useState(false);

  React.useEffect(() => setMounted(true), []);

  if (!mounted || typeof document === 'undefined') return null;
  return createPortal(children, document.body);
};

const Banner = ({ show, onClose = () => {} }) => {
  const { strapiBanner } = useStaticQuery(graphql`
    query BannerQuery {
      strapiBanner {
        Image {
          localFile {
            publicURL
          }
          mime
        }
        Title
        Pdf {
          localFile {
            publicURL
          }
        }
      }
    }
  `);

  // Only render if banner should be visible
  if (!show) return null;

  return (
    <Portal>
      <Content>
        <CloseButton onClick={onClose} type="button" />
        <Title>{strapiBanner.Title}</Title>
        <ImageWrapper>
          <img
            alt=""
            src={strapiBanner.Image?.localFile?.publicURL}
          />
        </ImageWrapper>
        <View
          href={strapiBanner.Pdf?.localFile?.publicURL}
          target="_blank"
          rel="noreferrer"
        >
          View
        </View>
      </Content>
    </Portal>
  );
};

export default Banner;